'use client';

import React from 'react';
import styled from 'styled-components';
import { ThreeDots } from 'svg-loaders-react';
import { colors } from '../../theme/color';

const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
`;

const StyledThreeDots = styled(ThreeDots)`
  margin: 100px auto;
  height: 20px;
  width: 50px;
  fill: ${colors.brandPrimary};
`;

export const PageLoading: React.FC = () => (
  <LoadingContainer aria-label="Sivua ladataan">
    <StyledThreeDots aria-hidden="true" />
  </LoadingContainer>
);
